import { standardWarningDescriptions } from "../../../Configurations/WarningConfigurations.js";
import type { WarningType } from "../../../WarningDescription.js";

/**
 * Mongoose validator for a `problemKey`/`fixKey` subschema field: the key must be
 * declared in the owning warning type's `<configField>` list. Standalone entries (no
 * owner document) skip the check, as does an unknown warningType — its own validator
 * is the sole reporter for that error.
 */
export function declaredKeyValidator(configField: "possibleProblemKeys" | "possibleFixKeys") {
    return {
        validator: function (this: unknown, value: unknown): boolean {
            if (value === null || value === undefined) return true;
            const owner = (this as { ownerDocument?: () => { warningType?: WarningType } }).ownerDocument?.();
            const warningType = owner?.warningType;
            const config = warningType ? standardWarningDescriptions[warningType] : undefined;
            if (!config) return true;
            const key = String(value);
            const allowed = config[configField] as readonly string[];
            if (!allowed.includes(key)) {
                throw new Error(`"${key}" is not in ${configField} for warningType "${warningType}"`);
            }
            return true;
        },
        message: (props: { reason?: { message?: string } }) => props.reason?.message ?? "value is invalid.",
    };
}
